const REVISION_INIT_NUM = 0;
const REVISION_ENABLE_NUM = 1;
const REVISION_DISABLE_NUM = 2;

export default {
	REVISION_INIT_NUM,
	REVISION_ENABLE_NUM,
	REVISION_DISABLE_NUM,
};
